// extracted by mini-css-extract-plugin
export default {"code":"product-code__code___1iV4m"};